/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { CREDIT_HISTORY, GATHER_INFO, REGULAR_CELLPHONE_REGISTRATION_NUMBER } from '../../../routes/routes';
import './Bling.css';
import { ProgressBar, Button, Form } from 'react-bootstrap';
import { navigateTo } from '../../../actions/navigationActions';
import NumberFormat from 'react-number-format';
import RequestCallBack from '../PortablePossessions/RequestCallBack';
import { postToController } from '../../../actions/apiActions';
import { setReplacementValue, setStartReplacementValue, checkReplacementValue, setPortablePossessionType, setCellphoneDetails } from '../../../actions/salesActions';
import { PRODUCT_BLING } from '../../../constants/constants';

class CellphoneDetails extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            replacementValue: "",
            loggedIn: this.props.auth.uid ? true : false,
            nextDisabled: true,
            hasSubmitted: false,
            selectedItem: "",
            cursor: 0,
            searchItems: [],
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.autocomplete = this.autocomplete.bind(this);
        this.hanldeKeyup = this.hanldeKeyup.bind(this);
        this.hanldeKeydown = this.hanldeKeydown.bind(this);
    }

    async componentDidMount() {
        if (this.props.sales.quoteType === PRODUCT_BLING) {
            this.props.dispatchSetPortablePossessionType(2, 'cellphone');
        }
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        let nextTobeDisabled = true;
        if (value == '-1') {
            value = ""
        }
        if (value) {
            nextTobeDisabled = false;
        }
        value = value.replace(this.props.profile.currencySymbol, "").replaceAll(",", "");
        await this.setState({ [name]: value });
        if (this.state.replacementValue.length > 0 && this.state.replacementValue.length !== 0) {
            await this.props.dispatchSetReplacementValue(Number(this.state.replacementValue));
            await this.props.dispatchCheckReplacementValue();
            this.props.dispatchSetCellphoneDetails(this.state.selectedItem.cellPhoneMakeId, this.state.selectedItem.cellPhoneModelId, this.state.selectedItem.cellPhoneMemoryTypeId, this.state.selectedItem.fullDescription);
        }
        this.setState({ nextDisabled: nextTobeDisabled });
    }

    async handleClick() {
        if (this.state.replacementValue.length > 0 && this.state.replacementValue.length !== '0') {
            await this.props.dispatchSetReplacementValue(Number(this.state.replacementValue));
            await this.props.dispatchCheckReplacementValue();
            this.props.dispatchSetCellphoneDetails(this.state.selectedItem.cellPhoneMakeId, this.state.selectedItem.cellPhoneModelId, this.state.selectedItem.cellPhoneMemoryTypeId, this.state.selectedItem.fullDescription);
            this.props.dispatchRedirectTo(REGULAR_CELLPHONE_REGISTRATION_NUMBER)
        }
    }

    async handleBack(e: any) {
        this.props.dispatchRedirectTo(GATHER_INFO)
    }

    async autocomplete(evt) {
        let text = evt.target.value;
        var listmax = 50;   //Make the search quicker - can't return full list
        var items = [];
        await this.setState({ selectedItem: text });
        await this.setState({ searchItems: [] });

        if (text && text.length >= 3) {
            await postToController(this.props.dispatch, 'CellphoneSearch', JSON.stringify({ SearchText: text, TopNResults: 10 }))
                .then(async (response) => {
                    if (response) {
                        items = response
                            .filter((i, index) => (index < listmax))
                            .map((i, index) => {
                                return (
                                    i
                                );
                            });
                        await this.setState({ searchItems: items });
                    }
                });
        }
    }

    hanldeKeyup(evt) {
        if (evt.keyCode === 27) {
            this.setState({ searchItems: [] });
            return false;
        }
    }

    hanldeKeydown(evt) {
        // arrow up/down button should select next/previous list element
        if (evt.keyCode === 38 && this.state.cursor > 0) {
            this.setState(prevState => ({
                cursor: prevState.cursor - 1
            }));
        } else if (evt.keyCode === 40 && this.state.searchItems && this.state.cursor && (this.state.cursor < this.state.searchItems.length - 1)) {
            this.setState(prevState => ({
                cursor: prevState.cursor + 1
            }));
        }
        if (evt.keyCode === 13) {
            let currentItem = this.state.searchItems[this.state.cursor];
            if (currentItem !== undefined) {
                this.setState({ searchItems: [] });
            }
        }
    }

    selectItem(item) {
        this.setState({ selectedItem: item, replacementValue: item.cellPhoneReplacementValue });
        this.setState({ searchItems: [] });
        var eventObj = {
            target: {
                name: "replacementValue",
                value: String(item.cellPhoneReplacementValue)
            }
        }
        this.handleChange(eventObj);
        this.props.dispatchSetCellphoneDetails(item.cellPhoneMakeId, item.cellPhoneModelId, item.cellPhoneMemoryTypeId, item.fullDescription);
    }

    public render() {
        const { replacementValue, hasSubmitted } = this.state;
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-0 logged-out"}>
                <div className="col-12 text-lg-center text-md-center">
                    <div className="container ssp-add-portable-possessions-replacement-value">
                        <div className="row justify-content-center mobile-mt-60px">
                            <div className="col-lg-12 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={40} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container mt-32px mobile-mt-20px">
                        <div className="row justify-content-center">
                            <div className="col-lg-12 col-md-12 nopa">
                                <div className="row noma">
                                    <div className="col nopa"></div>
                                    <div className="col-lg-10 nopa">
                                        <div className="ssp-addportable-possessions-crown-icon mt-0px text-center">
                                            <div className="ssp-sales-journey-crown-icon" title="Add portable possessions"></div>
                                        </div>
                                        <div className="ssp-cellphone-details-main-contentholder mt-21px mobile-mt-17px mb-30px text-center ssp-addreplacement-value-p-holder">
                                            <div className="mb-0px font-size-16px font-weight-500 ssp-addreplacement-value-intro-header">
                                                Please give us the make, model and replacement value of the phone you’d like to insure
                                            </div>
                                        </div>
                                        <div className="form-group mb-20px" id="cellphone-make-and-model">
                                            <Form.Label className={'left-align temp-text-box-label pl-1 mb-6px' + (this.state.selectedItem !== "" ? "" : " no-opacity d-none")}>Make and model</Form.Label>
                                            <input
                                                type="text"
                                                id="autocomplete"
                                                onChange={this.autocomplete}
                                                onKeyUp={this.hanldeKeyup}
                                                onKeyDown={this.hanldeKeydown}
                                                value={this.state.selectedItem.fullDescription}
                                                className="custom-input form-control"
                                                placeholder="Make and model"
                                            />
                                            {this.state.searchItems.length > 0 && (
                                                <ul id="makeAndModel" className="list-group">
                                                    {this.state.searchItems.map((item, idx) => (
                                                        <li
                                                            className={
                                                                this.state.cursor === idx ? "active list-group-item" : "list-group-item"
                                                            }
                                                            key={idx}
                                                            onClick={() => this.selectItem(item)}
                                                        >
                                                            {item.fullDescription}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                        {this.state.selectedItem === "" || this.state.selectedItem === undefined &&
                                            <div className="help-block mt-0">Make and model is required</div>
                                        }
                                        <div className="form-row noma ssp-addreplacement-value-tile-holder-row">
                                            <div className="col-12 nopa">
                                                <div className={'form-group mb-0px' + (hasSubmitted && replacementValue === "" ? ' has-error' : '')}>
                                                    <Form.Label className={'left-align temp-text-box-label pl-1 line-height-normal mb-6px' + (this.state.replacementValue !== "" ? "" : " no-opacity d-none")}>Replacement value</Form.Label>
                                                    <NumberFormat className={this.props.sales.replacementCheckResult !== "ok" && this.state.replacementValue !== "" ? "replacementValueInput invalid-cellphone form-control" : "replacementValueInput form-control"} id="ReplacementValueInputId" placeholder="Replacement value" name="replacementValue" thousandSeparator={true} thousandsGroupStyle="thousand" prefix={this.props.profile.currencySymbol} value={this.state.replacementValue} onChange={this.handleChange} />
                                                    {this.props.sales.replacementCheckResult !== "ok" && this.state.replacementValue !== "" &&
                                                        <p className="replacement-value-help-block mt-10px ml-20px mobile-ml-0px text-lg-left text-center">The value can’t be {this.props.sales.replacementCheckResult} than {this.props.profile.currencySymbol}{this.props.sales.replacementCheckResult === 'more' ? this.props.sales.MaxReplacementValue?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(".00", "") : this.props.sales.MinReplacementValue?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(".00", "")}</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        {this.props.sales.replacementCheckResult !== undefined && this.props.sales.replacementCheckResult !== "ok" && this.props.sales.replacementCheckResult !== "" && this.state.replacementValue !== "" && <RequestCallBack />}
                                        <div className="row noma justify-content-center mt-40px">
                                            <div className="col-lg-4 col-12 nopa cellphone-reg-button-holder">
                                                <button className="btn btn-block btn-solid-red button-width cursor-pointer" id="" disabled={this.state.nextDisabled || this.props.sales.replacementCheckResult != "ok"} onClick={this.handleClick}>Next</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        cart: state.cart,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchRedirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetReplacementValue: (value: string) => dispatch(setReplacementValue(Number(value))),
        dispatchSetStartReplacementValue: (value: string) => dispatch(setStartReplacementValue(value)),
        dispatchCheckReplacementValue: () => dispatch(checkReplacementValue()),
        dispatchSetPortablePossessionType: (id, itemType) => dispatch(setPortablePossessionType(id, itemType)),
        dispatchSetCellphoneDetails: (MakeId: number, ModelId: number, MemoryTypeId: number, Description: string) => dispatch(setCellphoneDetails(MakeId, ModelId, MemoryTypeId, Description)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CellphoneDetails);